"use strict";

var _classCallCheck = require("D:\\Dropbox\\projects\\justinireland.com\\justinirelandcom-cra\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("D:\\Dropbox\\projects\\justinireland.com\\justinirelandcom-cra\\node_modules\\@babel\\runtime/helpers/createClass");

var _possibleConstructorReturn = require("D:\\Dropbox\\projects\\justinireland.com\\justinirelandcom-cra\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("D:\\Dropbox\\projects\\justinireland.com\\justinirelandcom-cra\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

var _inherits = require("D:\\Dropbox\\projects\\justinireland.com\\justinirelandcom-cra\\node_modules\\@babel\\runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TrailMaker = void 0;

var Utils_1 = require("../../../Utils");

var Enums_1 = require("../../../Enums");

var ExternalInteractorBase_1 = require("../../../Core/ExternalInteractorBase");

var TrailMaker =
/*#__PURE__*/
function (_ExternalInteractorBa) {
  _inherits(TrailMaker, _ExternalInteractorBa);

  function TrailMaker(container) {
    var _this;

    _classCallCheck(this, TrailMaker);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TrailMaker).call(this, container));
    _this.delay = 0;
    return _this;
  }

  _createClass(TrailMaker, [{
    key: "interact",
    value: function interact(delta) {
      var _a, _b, _c, _d;

      if (!this.container.retina.reduceFactor) {
        return;
      }

      var container = this.container,
          options = container.actualOptions,
          trailOptions = options.interactivity.modes.trail,
          optDelay = trailOptions.delay * 1000 / this.container.retina.reduceFactor;

      if (this.delay < optDelay) {
        this.delay += delta.value;
      }

      if (this.delay < optDelay) {
        return;
      }

      var canEmit = true;

      if (trailOptions.pauseOnStop) {
        if (container.interactivity.mouse.position === this.lastPosition || ((_a = container.interactivity.mouse.position) === null || _a === void 0 ? void 0 : _a.x) === ((_b = this.lastPosition) === null || _b === void 0 ? void 0 : _b.x) && ((_c = container.interactivity.mouse.position) === null || _c === void 0 ? void 0 : _c.y) === ((_d = this.lastPosition) === null || _d === void 0 ? void 0 : _d.y)) {
          canEmit = false;
        }
      }

      if (container.interactivity.mouse.position) {
        this.lastPosition = {
          x: container.interactivity.mouse.position.x,
          y: container.interactivity.mouse.position.y
        };
      } else {
        delete this.lastPosition;
      }

      if (canEmit) {
        container.particles.push(trailOptions.quantity, container.interactivity.mouse, trailOptions.particles);
      }

      this.delay -= optDelay;
    }
  }, {
    key: "isEnabled",
    value: function isEnabled() {
      var container = this.container,
          options = container.actualOptions,
          mouse = container.interactivity.mouse,
          events = options.interactivity.events;
      return mouse.clicking && mouse.inside && !!mouse.position && (0, Utils_1.isInArray)(Enums_1.ClickMode.trail, events.onClick.mode) || mouse.inside && !!mouse.position && (0, Utils_1.isInArray)(Enums_1.HoverMode.trail, events.onHover.mode);
    }
  }, {
    key: "reset",
    value: function reset() {}
  }]);

  return TrailMaker;
}(ExternalInteractorBase_1.ExternalInteractorBase);

exports.TrailMaker = TrailMaker;